import React from 'react';

const HealthInsuranceOverview = (
  <>
    <p>In the next few questions, we’ll ask you about your health insurance.</p>

    <p>
      Health insurance includes any coverage that you get through a spouse or
      significant other. Health insurance also includes private insurance or
      insurance from your employer.
    </p>

    <p>
      We ask for this information for billing purposes only. Your health
      insurance coverage doesn’t affect the VA healthcare benefits you can get.
    </p>

    <va-additional-info trigger="Why giving us your health insurance information may help you">
      <div>
        <p className="vads-u-margin-top--0">
          <strong>
            Giving us your health insurance information may help you for these
            reasons:
          </strong>
        </p>
        <ul className="vads-u-margin-bottom--0">
          <li>
            We must bill your private health insurance provider for any care,
            supplies, or medicines we provide to treat your
            non-service-connected conditions. If you have a VA copay, we may be
            able to use the payments from your provider to cover some or all of
            your copay.
          </li>
          <li>
            Your private insurance provider may apply your VA healthcare charges
            toward your annual deductible. Your annual deductible is the amount
            of money you pay toward your care each year before your insurance
            starts to pay for care.
          </li>
        </ul>
      </div>
    </va-additional-info>
  </>
);

export default HealthInsuranceOverview;
